import apikeys from './apikeys';

export default function* () {
    yield* [...apikeys];
}
